import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
  "Content-Type": "application/json",
});

export const fetchSalesPersons = async () => {
  const response = await axios.get(`${API_BASE_URL}/sales-persons`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// Builds the display label for a combined sales-person entry, appending a
// "(Consultant)" / "(Sales)" tag derived from `type` so admins can tell a
// CRM consultant apart from a dedicated SalesPerson in plain <option> lists.
export const salesPersonOptionLabel = (sp = {}) => {
  const base = sp.name || sp.email || "Unknown";
  const type = sp.type || sp.userRole;
  if (type === "Consultant") return `${base} (Consultant)`;
  if (type === "SalesPerson") return `${base} (Sales)`;
  return base;
};

// Returns the combined SP + CRM-consultant list normalized to a consistent shape.
// Each item has: _id, name (derived from firstName+lastName for Consultant records),
// email, assignedBoardIds, type ("SalesPerson" | "Consultant").
export const fetchSalesPersonsNormalized = async () => {
  const res = await fetchSalesPersons();
  const list = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
  return list.map((item) => ({
    ...item,
    _id: item._id || item.id,
    name:
      item.name != null
        ? item.name
        : (`${item.firstName || ""} ${item.lastName || ""}`.trim() || item.email || ""),
  }));
};

export const registerSalesPerson = async (payload) => {
  const response = await axios.post(
    `${API_BASE_URL}/auth/register/sales-person`,
    payload,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const updateSalesPersonBoards = async (id, assignedBoardIds) => {
  const response = await axios.patch(
    `${API_BASE_URL}/sales-persons/${id}`,
    { assignedBoardIds },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const deleteSalesPerson = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/sales-persons/${id}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};
